





















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Assets from '@/constants/assets';

export interface SwitchIconsOption {
  id: number;
  src: string;
}

export enum IconSwitchColorSeparator {
  Primary = 'flat-selector-icon-switch--separator-primary',
  Secondary = 'flat-selector-icon-switch--separator-secondary',
}

@Component
export default class FlatSelectorIconSwitch extends Vue {
  @Prop() private selectedIcon!: SwitchIconsOption;
  @Prop() private iconOptions!: SwitchIconsOption[];
  @Prop() private colorSeparator!: IconSwitchColorSeparator;

  private isOpen: boolean = false;

  private get isOnlyOne() {
    return this.iconOptions.length <= 1;
  }

  private isIconSelected(icon: any) {
    return icon === this.selectedIcon;
  }

  private selectedOption(iconSelected: any) {
    this.isOpen = false;
    this.$emit('input', iconSelected);
  }

  private mouseEnter() {
    this.isOpen = true;
  }
  private mouseLeave() {
    this.isOpen = false;
  }
}
